import type { RegisterOptions } from "react-hook-form";

export type FormFieldConfig<TName extends string = string, TFieldExtendedParams = object> = TFieldExtendedParams & {
  name: TName;
  label?: string;
  isHidden?: boolean;
  placeholder?: string;
  isReadOnly?: boolean;
  isLoading?: boolean;
  registerOptions?: RegisterOptions;
};

export type FormFieldsConfig<TFieldNames extends string = string> = Record<TFieldNames, FormFieldConfig<TFieldNames>>;
